import { useContext } from 'react'
import {
  NotificationsContext,
  type NotificationsContextValue,
} from './notificationsContext'

export function useNotificationsContext(): NotificationsContextValue {
  const context = useContext(NotificationsContext)
  if (context === null) {
    throw new Error('useNotificationsContext must be used inside <NotificationsProvider>')
  }
  return context
}
